// @flow

import { observer } from "mobx-react";
import React from "react";

import ImageHelper from "app/util/ImageHelper";

import type { TimelineItemMetaImage } from "app/models/TimelineItem";
import TimelineItem from "app/models/TimelineItem";
import AppearanceStore from "app/stores/AppearanceStore";

import ShortComment from "app/components/ShortComment/ShortComment";

import "./UrlTimelineCard.scss";

type Props = {
    item: TimelineItem
};

@observer
export default class UrlTimelineCard extends React.Component<Props> {
    get length(): number {
        return AppearanceStore.timelineContentLength;
    }

    render() {
        const item = this.props.item;
        const src = this.grabImage(item.metaImage);

        const classes = ["TimelineCard--linkable"];
        if (item.metaImage && item.metaImage.type === "favicon") {
            classes.push("TimelineCard--linkable-favicon");
        }

        const url = "/content/clickthrough/" + item.rowid + "/" + item.url;

        // const hasText = item.metaTitle || item.metaDescription || item.comment.length > 0;
        // const imageContainerClass = hasText 
        //     ? "TimelineCard--linkable__imageContainer"
        //     : "TimelineCard--linkable__imageContainer_notext";

        return (
            <div className="UrlTimelineCard">

                <div className={classes.join(" ")}>

                    <div className="TimelineCard--linkable__container">
                        {/* 
                        { hasText &&
                            <div className={imageContainerClass}>
                                <a href={url} target="_blank">
                                    <img
                                        className="TimelineCard--linkable__image"
                                        src={src}
                                        alt="Timeline item"
                                    />
                                </a>
                            </div>
                        }
                        */}

                        <div className="TimelineCard--linkable__titleAndDescriptionContainer">

                            

                            {/* <a
                                href={url}
                                className="TimelineCard--linkable__description"
                                target="_blank"
                            >
                                {item.metaDescription}
                            </a> */}
                            <ShortComment
                                itemId={item.rowid}
                                comment={item.comment}
                                length={this.length}
                                key={item.rowid}
                            />
                            {item.metaTitle && (
                                // <a href={url} target="_blank">
                                //     <div className="TimelineCard--linkable__title">
                                //         {item.metaTitle}
                                //     </div>
                                // </a>
                                <div className="urlTimelineCardMeta">
                                    <a href={url} target="_blank">
                                        <div
                                            className="WizardTimelineCardPreview--url__image"
                                            style={{ backgroundImage: `url('${src}')` }}
                                            alt="Timeline item preview"
                                        />
                                        <div className="urlTimelineCardMeta-left-wrapper">
                                            <div className="WizardTimelineCardPreview--url__title">
                                                {item.metadata.title}
                                            </div>

                                            <div className="WizardTimelineCardPreview--url__description">
                                                {item.metadata.description}
                                            </div>

                                            <div className="WizardTimelineCardPreview--url__domain">
                                                {item.metadata.domain}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    grabImage(metaImage: ?TimelineItemMetaImage): ?string {
        if (!metaImage) return null;

        if (metaImage.type === "favicon") {
            return metaImage.src;
        }

        return ImageHelper.makeUrl(metaImage.src, undefined, { width: 160 });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/UrlTimelineCard/UrlTimelineCard.js